import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { addCommand, cancelSpaCommand, deleteCommand, editCommand, fetchCommands, fetchSpaCommands, fetchSpaCommandsHistory } from '../actions/commands.actions';
import ListState from '../states/list.state';

const initialState: ListState = {
  loading: false,
  data: [],
  error: null,
  meta: null,
};

const commandsSlice = createSlice({
  name: 'commands',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCommands.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCommands.fulfilled, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.data = action.payload.data;
        state.meta = action.payload.meta;
      })
      .addCase(fetchCommands.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload ?? null;
      })

      .addCase(fetchSpaCommands.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSpaCommands.fulfilled, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.data = action.payload.data;
        state.meta = action.payload.meta;
      })
      .addCase(fetchSpaCommands.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload ?? null;
      })

      .addCase(fetchSpaCommandsHistory.pending, (state, action) => {
        // A silent (auto-refresh) tick swaps rows in underneath the user rather than
        // tearing the table down to a spinner every few seconds.
        if (!action.meta.arg.silent) state.loading = true;
        state.error = null;
      })
      .addCase(fetchSpaCommandsHistory.fulfilled, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.data = action.payload.data;
        state.meta = action.payload.meta;
      })
      .addCase(fetchSpaCommandsHistory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload ?? null;
      })

      .addCase(addCommand.pending, (state) => {
          state.loading = true;
          state.error = null;
      })
      .addCase(addCommand.fulfilled, (state, action: PayloadAction<any>) => {
          state.loading = false;
          state.data = [action.payload,...state.data];
      })
      .addCase(addCommand.rejected, (state, action) => {
          state.loading = false;
          state.error = action.payload ?? null;
      })

      .addCase(deleteCommand.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteCommand.fulfilled, (state, action: PayloadAction<any>) => {
          state.loading = false;
          state.data = [...state.data].filter((command:any)=>{return command?.id!==action.payload});
      })
      .addCase(deleteCommand.rejected, (state, action) => {
          state.loading = false;
          state.error = action.payload ?? null;
      })
      .addCase(editCommand.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(editCommand.fulfilled, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.data = [...state.data].map((command:any)=>command?.id===action.payload?.id ? action.payload : command);
      })
      .addCase(editCommand.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload ?? null;
      })

      .addCase(cancelSpaCommand.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(cancelSpaCommand.fulfilled, (state, action: PayloadAction<any>) => {
        state.loading = false;
        // Remove the cancelled command from the list
        state.data = [...state.data].filter((command:any)=>command?.audit_id!==action.payload?.audit_id);
      })
      .addCase(cancelSpaCommand.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload ?? null;
      });
  },
});

export default commandsSlice.reducer;